import { version } from "@internal/package";
import { defineStore } from "@otto-ec/global-resources/nexus";
import { components } from "./common/component";
import { setColorScheme } from "./common/theme.js";

/*                                                                        */
import.meta.glob("./components/**/*.async.svelte", { eager: true });

/*                                                     */
const apis = Object.entries(
  import.meta.glob<true, string, Record<string, unknown>>("./components/**/*.api.ts", {
    eager: true,
  }),
).map(([path, module]) => {
  const name = path.match(/\/([^/]+)\.api\.ts$/)?.[1];

  if (import.meta.env.DEV && !name) {
    throw new Error(`Could not parse component name from path: ${path}`);
  }

  const key = name![0].toLowerCase() + name!.slice(1);
  const api = module[key];
  if (import.meta.env.DEV && !api) {
    throw new Error(`Module ${path} does not export ${key}`);
  }

  return { [key]: api };
});

components.assignNamespace(
  Object.assign(
    { version: () => version, setColorScheme, asyncComponentsLoaded: defineStore(true) },
    ...apis,
  ),
);

const focusTagname = "oc-floating-focus-v1";
if (!document.querySelector(focusTagname)) {
  const floaterElement = document.createElement(focusTagname);
  document.body.append(floaterElement);
}
